export default __webpack_public_path__ + "static/media/coffee-servant.b83289e2.svg";